import {type IconName} from '@wandb/weave/components/Icon';
import React, {type FC} from 'react';
import {useSlateStatic} from 'slate-react';

import {EditorWithMarkShortcuts} from '../plugins/mark-shortcuts';
import * as S from './HoveringToolbar.styles';

interface FormatButtonProps {
  format: string;
  icon: IconName;
}

export const FormatButton: FC<FormatButtonProps> = ({format, icon}) => {
  // TODO(react-compiler): queries a Slate editor that is mutated in place;
  // compiled output would cache the result.
  'use no memo';
  const editor = useSlateStatic();
  return (
    <S.FormatButton
      name={icon}
      $active={EditorWithMarkShortcuts.hasMark(editor, format)}
      onMouseDown={(e: Event) => e.preventDefault()}
      onClick={() => {
        EditorWithMarkShortcuts.toggleMark(editor, format);
      }}
    />
  );
};
